<template>
  <div id="app" class="uk-container uk-margin-large-top uk-margin-bottom uk-text-center">
    <img width="150px" src="./assets/TeslaT.svg">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
html {
  background-color: #1f1f1f;
  color: #b3b3b3;
  font-size: 16px;
}
h1 {
  color: #e0e0e0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue